<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Mantenimiento de Prendas'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-md-6">
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="'col-md-8'">
              <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codBaan')"
                [placeholder]="'Codigo BAAN'" formControlName="codBaan" [label]="'Ingrese Codigo*'" [type]="'text'" [id]="'codBaan'">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-4'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarPrenda()">Buscar</button>
            </div>
            <div [class]="'col-md-12'">
              <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('descrp')"
                [placeholder]="'Descripción'" formControlName="descrp" [label]="'Ingrese Descripción*'" [type]="'text'" [id]="'descrp'">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-12'">
              <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('punit')"
                [placeholder]="'Precio'" formControlName="punit" [label]="'Ingrese Precio*'" [type]="'text'" [id]="'punit'">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-12'">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <label>&nbsp;</label><br>
                <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
                  (click)="crearClothes()">Guardar</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="col-md-6">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
            No existen datos para la lista de Parametros Inicial.
          </div>
          <div *ngIf="!listaVacia">
            <div class="row">
              <div [class]="'col-md-12'">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
                  (keyup)="onQuickFilterChanged()" #quickFilter />
              </div>
            </div>
            <div [class]="'col-md-12'">
              <ag-grid-angular #agGrid class=" {{uniformeModulo.agGrid.class}}" [ngStyle]="uniformeModulo.agGrid.style"
                id="{{uniformeModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"
                [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
                 (cellClicked)="setGrupoSize($event)">
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<br>